import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@utex/ui-kit';

import { MobileMenu } from '../../components/MobileMenu';
import { Loader } from '../Loader';
import { Sidebar, Menu, Container, Form, FormContent, FormFooter } from './styles';
import { Title } from './components/Title';
import { SoftBlockChecker } from './components/SoftBlockChecker';

interface Props {
  menu: JSX.Element;
  select: JSX.Element;
  content: JSX.Element;
  error: JSX.Element | null;
  loading: boolean;
}

export const Layout: React.FC<Props> & {
  Menu: typeof Menu;
  Form: typeof Form;
  FormContent: typeof FormContent;
  FormFooter: typeof FormFooter;
} = ({ error, menu, select, content, loading }) => {
  useTranslation(['validator', 'exception']);

  if (loading) {
    return (
      <Container>
        <Loader />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Title />
        {error}
      </Container>
    );
  }

  return (
    <Container>
      <Title />
      <Box display="flex" flexDirection={{ phonablet: 'column' }} flexGrow={1}>
        <Sidebar>
          <Box display={{ phonablet: 'none' }}>{menu}</Box>
          <Box display={{ tablesktop: 'none' }}>
            <MobileMenu menu={menu} currentItem={select} />
          </Box>
        </Sidebar>
        <SoftBlockChecker>{content}</SoftBlockChecker>
      </Box>
    </Container>
  );
};

Layout.Menu = Menu;
Layout.Form = Form;
Layout.FormContent = FormContent;
Layout.FormFooter = FormFooter;
